export function formatCurrencyForDisplay(value = 0) {
    return new Intl.NumberFormat('en-US').format(value);
}
